export const urls = {
  aeropayAccounts: '/kiosk/users/aeropay/accounts',
  bankConnections: '/kiosk/users/aeropay/bank_connections',
  deleteBankAccount: '/kiosk/users/aeropay/bank_connections',
  selectBankAccount:
    '/kiosk/users/aeropay/bank_connections/select_bank_account',
};

const queryKeyBase = ['kiosk', 'aeropay'];

export const queryKeys = {
  aeropayUser: ({ janeUserId }: { janeUserId?: string | number }) => [
    ...queryKeyBase,
    'user',
    janeUserId,
  ],
  bankConnections: () => [...queryKeyBase, 'bankConnection'],
};
